import { LoadableAfterPaint } from '@confluence/loadable';

export type { PageTreeMacroParams } from '../src/PageTreeMacroRenderer.tsx';

export const PageTreeMacroHandler = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-PageTreeMacro" */ '../src/PageTreeMacroRenderer.tsx'
			)
		).PageTreeMacroRenderer,
});
